import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { addTeamMember, changeOrganizationInitStatus } from '../actions'

class OrganizationForm extends Component {
  componentWillMount() {
    this.initializeForm()
  }
  componentWillUpdate() {
    if(this.props.initForm){
      this.initializeForm()
    }
  }
  initializeForm() {
    const { initialize, editTeam, editMembers, changeOrganizationInitStatus } = this.props
    initialize({ 
      teamId: editTeam,
      members: editMembers,
      user: ""
    })
    changeOrganizationInitStatus(false)
  }
  render() {
    const { users, handleSubmit, addTeamMember } = this.props
    return (
      <form onSubmit={handleSubmit(values => addTeamMember(values))} >
        <Field name="teamId" component="input" type="hidden" />
        <Field name="members" component="input" type="hidden" />
        <div className="field has-addons">
          <div className="control">
            <div className="select is-small">
              <Field name="user" component="select">
                <option value=""> - </option>
                {Object.keys(users).map(uid => 
                  <option value={uid} key={uid}>{users[uid].realName}</option>
                )}
              </Field>
            </div>
          </div>
          <div className="control">
            <button type="submit" className="button is-small">保存</button>
          </div>
        </div>
      </form>
    )
  }
}

export default connect(
  state => ({
    initForm: state.organization.initForm,
    editTeam: state.organization.editTeam,
    editMembers: state.organization.editMembers,
    users: state.users
  }),
  { addTeamMember, changeOrganizationInitStatus }
)(reduxForm({ form: 'organization' })(OrganizationForm))



// WEBPACK FOOTER //
// ./src/components/OrganizationForm.js